export default "__VITE_ASSET__BzZla6ac__"